import Work from "../../../utils/assets/work.png";
import Spring from "../../../utils/assets/spring.png";
import Materials from "../../../utils/assets/materials.png";
import Men from "../../../utils/assets/men.png";
import Service1 from "../../../utils/assets/dry.png";
import Commercial from "../../../utils/assets/commercial.png";

const ServicesData = [
  {
    id: 1,
    title: "Residential Cleaning",
    desc: "Our cleaning style is thorough, detail-oriented, and customized to your needs.",
    cover: Work,
  },
  {
    id: 2,
    title: "Exit Cleaning",
    desc: "Our team consists of trained professionals who deliver exceptional cleaning services.",
    cover: Men,
  },
  {
    id: 3,
    title: "Eco-friendly Options",
    desc: "We use top-of-the-line equipment to ensure high quality cleaning results.",
    cover: Materials,
  },
  {
    id: 4,
    title: "Laundary / Dry Cleaning",
    desc: "Our laundry and dry cleaning services keep your clothes looking their best.",
    cover: Service1,
  },
  {
    id: 5,
    title: "Commercial Cleaning ",
    desc: "Our commercial cleaning services create a clean and healthy work environment for your business.",
    cover: Commercial,
  },
  {
    id: 6,
    title: "Spring / Deep Cleaning",
    desc: "Our spring/deep cleaning services refresh and revitalize your space for a fresh start.",
    cover: Spring,
  },
];

export default ServicesData;
